var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-background-gradient"},[_c('div',{staticClass:"container max-w-1100"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"d-flex gap-4 w-100 justify-content-end my-3"},[_c('language-select',{on:{"change":_vm.setAppLanguage}})],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }